import { createHttp, createPlatformApi, localSessionStore, PLATFORM_REFRESH_PATH, type PlatformLogin } from '@vlm/api';
import { env } from '../env';

export const SESSION_KEY = 'vlm.platform.session';

/** The platform's own tokens (never the admin's): every tab shares one sign-in. */
export const sessionStore = localSessionStore(SESSION_KEY);

/** Set by auth.ts: what to do when the refresh token is gone, and with the user a refresh brings back. */
export const sessionEvents: { expired: () => void; refreshed: (login: PlatformLogin) => void } = {
  expired: () => {},
  refreshed: () => {},
};

export const http = createHttp<PlatformLogin>({
  baseUrl: env.apiUrl,
  session: sessionStore,
  refreshPath: PLATFORM_REFRESH_PATH,
  onSessionExpired: () => sessionEvents.expired(),
  onRefreshed: (login) => sessionEvents.refreshed(login),
});

export const api = createPlatformApi(http);

/** Saves a file the API handed back (an invoice PDF). */
export function saveFile(file: { blob: Blob; filename: string }) {
  const url = URL.createObjectURL(file.blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.filename;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
